import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AppFooter = styled.footer``

export const AppFooterContentContainer = styled.div`
  display: flex;
  margin: 0 7.5%;
  margin-top: 90px;
  margin-bottom: 40px;
  justify-content: space-between;
`

export const AppFooterCopyrightContainer = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.primary};
  height: 64px;
`
export const AppFooterLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 15%;
`

export const AppFooterMiddleContainer = styled.div`
    display: flex;
    width: 100%;
    margin-left: 15%;
`

export const AppFooterLink = styled(Link)`
  margin-bottom: 18%;
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.blackSecondary};
  transition: all 0.25s ease-in;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const AppFooterCopyrightText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white};
  margin-left: 10%;
`
export const AppFooterText = styled.p`
  margin: 0;
  margin-bottom: 10px;
  font-size: 14px;
`

export const AppFooterColumbiaContainer = styled.div`
  margin-top: -5px;
`

export const AppFooterLogo = styled.img`
  max-width: 8.35rem;
`

export const AppFooterColumbiaLogo = styled.img`
  max-width: 8.35rem;
`

export const AppFooterSocialMedia = styled.img`
  max-width: 8.35rem;
  margin: 0px 7px;
`
export const AppFooterSocialMediaContainer = styled.div`
  display: flex;
  margin-top: 56px;
`
export const AppFooterLocationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
